"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BinaryOutcomeDomainDropdown = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var react_redux_1 = require("react-redux");
var SubspaceSlice_1 = require("../../store/slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../../store/thunk/PredictiveModelThunk");
var ObjectiveSelectionStyles_1 = require("../../styles/ObjectiveSelectionStyles");
var TestIds_1 = require("../../util/TestIds");
var Utils_1 = require("../../util/Utils");
var StateSelectors_1 = require("../StateSelectors");
var BinaryOutcomeDomainDropdown = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var selectedObjective = (0, react_redux_1.useSelector)(StateSelectors_1.objectiveSelector);
    var domainRetrievalStatus = (0, react_redux_1.useSelector)(StateSelectors_1.domainRetrievalStatusSelector);
    var getBinaryOutcomeDomainList = function () {
        var listItems = [];
        if (selectedObjective && selectedObjective.domain && selectedObjective.domain.length === 2) {
            listItems = selectedObjective.domain.map(function (val) { return ({
                content: selectedObjective.outcomeField.concat(': ', val),
                value: val,
            }); });
        }
        return listItems;
    };
    var handleChangeCallback = function (successValue) {
        var failureValue = successValue === selectedObjective.domain[0] ? selectedObjective.domain[1] : selectedObjective.domain[0];
        dispatch((0, SubspaceSlice_1.updateObjective)({ value: successValue, type: 'successValue' }));
        dispatch((0, SubspaceSlice_1.updateObjective)({
            value: failureValue,
            type: 'failureValue',
        }));
        dispatch((0, PredictiveModelThunk_1.updateModel)({ objectiveSuccessValue: successValue, objectiveFailureValue: failureValue }));
    };
    return (React.createElement("div", { className: ObjectiveSelectionStyles_1.OutcomeDropdownContainerStyle },
        React.createElement(widgets_1.SingleSelectDropdown, { label: '', testId: TestIds_1.BINARY_DOMAIN_DROPDOWN_LIST_TEST_ID, list: React.createElement(widgets_1.List, { style: { maxHeight: 250 }, items: getBinaryOutcomeDomainList() }), onChange: function (field) {
                handleChangeCallback(field);
            }, type: widgets_1.DropdownButtonType.Outline, value: selectedObjective.successValue, disabled: domainRetrievalStatus === Utils_1.DomainRetrievalStatus.Retrieving }, selectedObjective.successValue)));
};
exports.BinaryOutcomeDomainDropdown = BinaryOutcomeDomainDropdown;
//# sourceMappingURL=BinaryOutcomeDomainDropdown.js.map